document.addEventListener( 'DOMContentLoaded', () => {
	const isHemolysisPage = document.querySelector( '.page-template-template-4-3-understanding-hemolysis' );
	const hasAnchorLink = window.location.href.indexOf( '#ivh-evh-symptoms' ) !== -1;
	if ( isHemolysisPage && hasAnchorLink ) {
		if ( window.matchMedia( '(min-width: 40em)' ) ) {
			console.log( 'mobile id' );
			document.getElementById( 'ivh-evh-symptoms-mobile' ).scrollIntoView();
		}
	}
} );
